import { useQuery } from '@tanstack/react-query';
import { licensesManageService } from '../api/licensesManageService';

export function useLicenseSessionsQuery(licenseId: string | undefined) {
  return useQuery({
    queryKey: ['manage-licenses', 'sessions', licenseId],
    queryFn: () => licensesManageService.activeSessions(licenseId!),
    enabled: !!licenseId,
    staleTime: 10_000,
  });
}
